"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetType = void 0;
var DatasetType;
(function (DatasetType) {
    DatasetType["Single"] = "single";
    DatasetType["Pair"] = "pair";
    DatasetType["Triple"] = "triple";
    DatasetType["Quadruple"] = "quadruple";
})(DatasetType || (exports.DatasetType = DatasetType = {}));
